import type { AdminNewTemplate } from "../api/generated";

type EquipmentTypeValue = NonNullable<AdminNewTemplate["equipmentType"]>;

export interface EquipmentTypeOption {
  name: string;
  value: EquipmentTypeValue;
}

export const EquipmentTypes: EquipmentTypeOption[] = [
  {
    name: "חדר כושר מסחרי",
    value: "GYM"
  },
  {
    name: "חדר כושר קטן",
    value: "SMALL_GYM"
  },
  {
    name: "סטודיו",
    value: "STUDIO"
  },
  {
    name: "חדר כושר בייתי",
    value: "HOME_GYM"
  },
];
